import { render, staticRenderFns } from "./dashSwitchHeader.vue?vue&type=template&id=7448551a"
import script from "./dashSwitchHeader.vue?vue&type=script&lang=js"
export * from "./dashSwitchHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports